// Central runtime configuration. Every external connection is env-driven so the
// storefront can be pointed at a real WooCommerce backend without code changes.
const env = {
  storeName: process.env.REACT_APP_STORE_NAME || "KHA",
  woo: {
    storeApiUrl: (process.env.REACT_APP_WOO_STORE_API_URL || "").replace(/\/$/, ""),
    restApiUrl: (process.env.REACT_APP_WOO_REST_API_URL || "").replace(/\/$/, ""),
    consumerKey: process.env.REACT_APP_WOO_CONSUMER_KEY || "",
    consumerSecret: process.env.REACT_APP_WOO_CONSUMER_SECRET || "",
  },
  useMock: process.env.REACT_APP_USE_MOCK === "true",
  defaultLang: process.env.REACT_APP_DEFAULT_LANG || "en",
  defaultCurrency: process.env.REACT_APP_DEFAULT_CURRENCY || "USD",
};

// Woo is considered "connected" only when a Store API URL is provided.
export const isWooConfigured = () => Boolean(env.woo.storeApiUrl);

export default env;
